import React from 'react';
import { motion } from 'framer-motion';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function HeaterHire() {
  const features = ['Fan-assisted & IDF variants', 'Broad thermal output range', 'Pre-noon same day dispatch', 'Commercial & industrial use', 'Technical sizing support', 'UK-wide deployment'];
  return <main className="flex-grow" data-id="element-410">
      <ServicePageHero title="Portable Heater Hire" subtitle="Rapidly deployable space heating solutions designed to maintain optimal temperatures in any environment." data-id="element-411" />

      <section className="py-20 bg-white" data-id="element-412">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-413">
          <div className="flex flex-col lg:flex-row-reverse gap-16 items-start" data-id="element-414">
            {/* Content Right (Alternated layout) */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-2/3" data-id="element-415">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-6" data-id="element-416">
                Adaptable Space Heating
              </h2>

              <div className="space-y-6 text-brand-slate text-lg leading-relaxed mb-10" data-id="element-417">
                <p data-id="element-418">
                  Explore our comprehensive inventory of fan-assisted and
                  indirect diesel fired (IDF) heating units, ready for immediate
                  dispatch throughout the UK. Our portable systems are
                  engineered to deliver the precise thermal output required
                  across diverse industrial and commercial sectors.
                </p>
                <p data-id="element-419">
                  Whether you are heating an administrative office, a
                  manufacturing floor, or a temporary event structure, we
                  possess the appropriate hardware. If you require assistance
                  calculating the necessary thermal load or selecting the
                  optimal unit type, our technical advisors are available to
                  specify the ideal configuration.
                </p>
                <p data-id="element-420">
                  Logistics are streamlined for maximum speed. We guarantee{' '}
                  <strong data-id="element-421">
                    same-day dispatch on all portable heating units
                  </strong>{' '}
                  provided the request is finalized before midday.
                </p>
                <p data-id="element-422">
                  For immediate critical requirements, we strongly advise
                  contacting our emergency dispatch line directly at{' '}
                  <a href="tel:08004647025" className="font-bold text-brand-navy hover:text-brand-amber transition-colors" data-id="element-423">
                    0800 464 7025
                  </a>
                  .
                </p>
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-6" data-id="element-424">
                Equipment Highlights
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-425">
                {features.map((feature, i) => <span key={i} className="bg-brand-light border border-gray-200 text-brand-navy px-4 py-2 rounded-full text-sm font-medium" data-id="element-426">
                    {feature}
                  </span>)}
              </div>
            </motion.div>

            {/* Sidebar Left */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/3 w-full sticky top-24" data-id="element-427">
              <div className="bg-brand-navy p-8 rounded-xl text-white mb-8" data-id="element-428">
                <h3 className="text-xl font-heading font-bold mb-4" data-id="element-429">
                  Quick Inquiry
                </h3>
                <p className="text-sm text-gray-400 mb-6" data-id="element-430">
                  Need heaters urgently? Call our 24/7 dispatch team.
                </p>
                <a href="tel:08004647025" className="block w-full text-center bg-brand-amber text-brand-navy font-bold py-3 rounded hover:bg-white transition-colors" data-id="element-431">
                  0800 464 7025
                </a>
              </div>
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-Fleet.webp" alt="Rapid Energy Delivery Fleet" className="rounded-xl shadow-lg w-full object-cover" data-id="element-432" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Other Services Strip */}
      <section className="bg-brand-light py-8 border-y border-gray-200" data-id="element-433">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-434">
          <span className="text-brand-slate font-medium" data-id="element-435">Explore more:</span>
          <Link to="/boiler-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-436">
            Temporary Boilers
          </Link>
          <Link to="/chiller-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-437">
            Industrial Chillers
          </Link>
          <Link to="/ancillaries" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-438">
            Ancillary Equipment
          </Link>
        </div>
      </section>

      <CTASection data-id="element-439" />
    </main>;
}